function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { MboxEvents, event } from "./qmEvents";
var MBOX_ACTIVE_EVENT_ID = MboxEvents.MBOX_ACTIVE_EVENT_ID, MBOX_USED_EVENT_ID = MboxEvents.MBOX_USED_EVENT_ID, MBOX_RESPONSE_TYPE_EVENT_ID = MboxEvents.MBOX_RESPONSE_TYPE_EVENT_ID, MBOX_RESPONSE_FEATURES_EVENT_ID = MboxEvents.MBOX_RESPONSE_FEATURES_EVENT_ID, TOTAL_MBOX_ACTIVE_EVENT_ID = MboxEvents.TOTAL_MBOX_ACTIVE_EVENT_ID, TOTAL_MBOX_USED_EVENT_ID = MboxEvents.TOTAL_MBOX_USED_EVENT_ID, GLOBAL_PARAMETER_COUNT_EVENT_ID = MboxEvents.GLOBAL_PARAMETER_COUNT_EVENT_ID, PAGE_PARAMETER_COUNT_EVENT_ID = MboxEvents.PAGE_PARAMETER_COUNT_EVENT_ID, MBOX_PARAMETER_COUNT_EVENT_ID = MboxEvents.MBOX_PARAMETER_COUNT_EVENT_ID, MBOX_PROFILE_PARAMETER_COUNT_EVENT_ID = MboxEvents.MBOX_PROFILE_PARAMETER_COUNT_EVENT_ID;
export var getGlobalParametersEvents = function(globalParameters) {
    if (globalParameters === void 0) globalParameters = {};
    return [
        event(GLOBAL_PARAMETER_COUNT_EVENT_ID, Object.keys(globalParameters).length)
    ];
};
export var getPageParametersEvents = function(pageParameters) {
    if (pageParameters === void 0) pageParameters = {};
    // Not sure if we actually care what the parameters or, or their values since these aren't defined inside lapel
    // Just knowing how many parameters are being used seems reasonable so we can detect if it's becoming too much (over 50)
    return [
        event(PAGE_PARAMETER_COUNT_EVENT_ID, Object.keys(pageParameters).length)
    ];
};
export var getMboxFeaturesEvents = function(param) {
    var tmp = param.options, _ref = _sliced_to_array(tmp === void 0 ? [
        {}
    ] : tmp, 1), _ref_ = _ref[0], type = _ref_.type, content = _ref_.content;
    var features = new Set([
        "evar",
        "evarValue",
        "props",
        "cookies",
        "storage",
        "tunnel",
        "component",
        "remote",
        "mergeChildProps",
        "script"
    ]);
    var events = [
        event(MBOX_RESPONSE_TYPE_EVENT_ID, type)
    ];
    if (content && typeof content === "object") {
        Object.keys(content).forEach(function(key) {
            if (features.has(key)) {
                events.push(event(MBOX_RESPONSE_FEATURES_EVENT_ID, key));
            }
        });
    }
    return events;
};
export var getMboxParametersEvents = function(param) {
    var _param_parameters = param.parameters, parameters = _param_parameters === void 0 ? {} : _param_parameters;
    return [
        event(MBOX_PARAMETER_COUNT_EVENT_ID, Object.keys(parameters).length)
    ];
};
export var getMboxProfileParametersEvents = function(param) {
    var _param_profileParameters = param.profileParameters, profileParameters = _param_profileParameters === void 0 ? {} : _param_profileParameters;
    return [
        event(MBOX_PROFILE_PARAMETER_COUNT_EVENT_ID, Object.keys(profileParameters).length)
    ];
};
export var getMboxResultEvents = function(mbox) {
    var name = mbox.name, options = mbox.options;
    var events = [
        event(MBOX_USED_EVENT_ID, name)
    ];
    if (options) {
        var _events;
        events.push(event(MBOX_ACTIVE_EVENT_ID, name));
        (_events = events).push.apply(_events, _to_consumable_array(getMboxFeaturesEvents(mbox)));
    }
    return events;
};
export var getMboxRequestEvents = function(toFetch, globalParameters, pageParameters) {
    if (toFetch === void 0) toFetch = [];
    if (globalParameters === void 0) globalParameters = {};
    if (pageParameters === void 0) pageParameters = {};
    var events = _to_consumable_array(getGlobalParametersEvents(globalParameters)).concat(_to_consumable_array(getPageParametersEvents(pageParameters)));
    if (Array.isArray(toFetch)) {
        var _events;
        var expandedEvents = toFetch.reduce(function(acc, mbox) {
            var _acc;
            (_acc = acc).push.apply(_acc, _to_consumable_array(getMboxParametersEvents(mbox)).concat(_to_consumable_array(getMboxProfileParametersEvents(mbox))));
            return acc;
        }, []);
        (_events = events).push.apply(_events, _to_consumable_array(expandedEvents));
    }
    return events;
};
export var getMboxResultsEvents = function(fetched) {
    if (fetched === void 0) fetched = [];
    var events = [
        event(TOTAL_MBOX_USED_EVENT_ID, fetched.length)
    ];
    var active = 0;
    fetched.forEach(function(mbox) {
        var _events;
        if (mbox.options) {
            active += 1;
        }
        (_events = events).push.apply(_events, _to_consumable_array(getMboxResultEvents(mbox)));
    });
    events.push(event(TOTAL_MBOX_ACTIVE_EVENT_ID, active));
    return events;
};

//# sourceMappingURL=mboxes.js.map